import type { SessionRecordingService } from './SessionRecordingService'
import type Member from 'iam/models/Member'
import type UserData from 'iam/models/UserData'

/**
 * No-op session recording implementation.
 * Used when PostHog is not configured (e.g., local development).
 * Logs actions to console for debugging purposes.
 */
export class NoOpSessionRecordingService implements SessionRecordingService {
  // Logs user identification without actually tracking
  identify(member: Member, _userData: UserData) {
    console.debug('[NoOp] Identifying as', member.displayName)
  }

  // Logs reset action without actually clearing anything
  reset() {
    console.debug('[NoOp] Resetting session recording')
  }

  // Factory method for creating service instances
  static create() {
    return new NoOpSessionRecordingService()
  }
}
